import * as React from "react";
import ModelConstDisclosureManager from "./ModelConstDisclosureManager";
import ModelConstDisclosureCoverPage from "./ModelConstDisclosureCoverPage";

const ModelConstDisclosureSection = ({ portfolio, cprRecommendation, userIsApproved }) => {
  if (
    !cprRecommendation.managers ||
    !cprRecommendation.modelConstituentDisclosure.length
  ) {
    return null;
  }

  return (
    <React.Fragment>
      {/*Model Constituent Disclosure Cover Page*/}
      <ModelConstDisclosureCoverPage portfolio={portfolio} />
      {cprRecommendation.modelConstituentDisclosure.map((model) => {
        const manager = cprRecommendation.managers.find(
          (m) => m.managerCode === model.managerCode
        );
        return (
          <ModelConstDisclosureManager
            key={model.managerCode}
            portfolio={portfolio}
            manager={manager}
            model={model}
            userIsApproved={userIsApproved}
          />
        );
      })}
    </React.Fragment>
  );
};

export default ModelConstDisclosureSection;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/ModelConstDisclosureSection.jsx